import React, {Fragment} from 'react';
import Divider from "../Styles/Divider";

type NamedInformation = {
    label: string,
    value: string
}

type InformationListProps = {
    informations: string[] | NamedInformation[],
    dividerOutside?: boolean,
    withDivider?: boolean
}

export function InformationList(props: InformationListProps) {
    const {informations, dividerOutside, withDivider = true} = props
    return (
        <ul className={"molekules-two-informationlist"}>
            <Fragment>
                {dividerOutside ? <Divider/> : null}
                {
                    informations.map((information, index) =>
                        <Fragment>
                            <li key={typeof information === "string" ? information : information.label} className={"information"}>
                                {typeof information === "string" ? information :
                                    <Fragment>
                                        <span>{information.label}</span>
                                        <span>{information.value}</span>
                                    </Fragment>
                                }
                            </li>
                            {withDivider && index !== informations.length - 1 ? <Divider/> : null}
                        </Fragment>
                    )
                }
                {dividerOutside ? <Divider/> : null}
            </Fragment>
        </ul>
    );
}

export default InformationList;
